<template>
  <div class="tab">
    <el-footer v-if="$can('create', 'sip-servers')" class="tab__footer page__active_bar">
      <el-button
        id="addServer"
        class="page__active_button"
        type="primary"
        icon="el-icon-plus"
        @click="$router.push({ name: 'sip-server:create' })"
      >
        Добавить
      </el-button>
    </el-footer>
    <div class="page_container">
      <search 
        :query.sync="query" 
        @search="search" 
      />
      <sip-servers-table @serverDeleted="changePage(page)" />
      <el-pagination
        class="list__pagination"
        layout="prev, pager, next"
        :page-size="count"
        :total="total"
        :current-page="page"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import Search from "@/components/Search";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import list from "@/core/mixins/list";
import SipServersTable from "@/components/SipServers/features/SipServersTable";

export default {
  name: "SipServersList",
  components: {
    SipServersTable,
    Search,
  },
  mixins: [list],
  data() {
    return { query: "", activeName: "list"};
  },
  computed: {
    ...mapState("sip_servers", ["total", "count"]),
    ...mapGetters("sip_servers", ["getQuery"]),
  },
  methods: {
    ...mapActions("sip_servers", {
      getList: "GET_LIST_SIP_SERVERS",
    }),
    ...mapMutations("sip_servers", {
      setQuery: "SET_QUERY",
    }),
  },
};
</script>

<style>
.list,
.list__pagination {
  margin: 20px 0;
}
.list__pagination {
  text-align: center;
}
.el-table th > .cell {
  word-break: break-word;
}
.link {
  line-height: 1;
  cursor: pointer;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  color: #409eff;
}
</style>
